import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Signature = () => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pager, setPager] = useState({ currentPage: 1, totalCount: 0, pageCount: 1, perPage: 25 });

  const loadTemplates = async (p = 1, s = '') => {
    try {
      setLoading(true);
      setError('');
      const res = await axios.get('/api/signature/templates', { params: { force: true, search: s } });
      const list = Array.isArray(res.data?.data) ? res.data.data : [];
      setTemplates(list);
      setPager(res.data?.pager || { currentPage: p, totalCount: list.length, pageCount: 1, perPage: list.length });
    } catch (e) {
      setError(e?.response?.data?.message || 'Falha ao carregar templates');
      setTemplates([]);
      setPager({ currentPage: 1, totalCount: 0, pageCount: 1, perPage: 25 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadTemplates(1, ''); }, []);

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <div className="card">
        <div className="card-header">
          <h2 className="card-title">Templates Assinafy</h2>
        </div>
        <div className="card-body space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            <input className="form-input" value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar por nome" aria-label="Buscar templates" />
            <button className="btn btn-primary" onClick={() => { setPage(1); loadTemplates(1, search); }} disabled={loading}>{loading ? 'Carregando...' : 'Buscar'}</button>
            <button className="btn btn-outline" onClick={() => { setSearch(''); setPage(1); loadTemplates(1, ''); }}>Limpar</button>
          </div>
          {error && (
            <div className="text-sm text-error" role="alert">{error}</div>
          )}
          <div className="tithers-table-container">
            <table className="tithers-table">
              <thead>
                <tr>
                  <th className="name-column">Nome do Template</th>
                  <th>Identificador</th>
                  <th>Data de Criação</th>
                </tr>
              </thead>
              <tbody>
                {templates.map((t, idx) => (
                  <tr key={`tpl-${t.id || idx}`}>
                    <td className="name-column font-medium">{t.name || t.title || '-'}</td>
                    <td>{t.id || t._id || '-'}</td>
                    <td>{t.created_at ? new Date(t.created_at).toLocaleDateString('pt-BR') : (t.createdAt ? new Date(t.createdAt).toLocaleDateString('pt-BR') : '-')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex items-center gap-2">
            <button className="btn btn-sm btn-outline" disabled={pager.currentPage <= 1 || loading} onClick={() => { const p = Math.max(1, pager.currentPage - 1); setPage(p); loadTemplates(p, search); }}>Anterior</button>
            <span className="text-sm">Página {pager.currentPage} de {pager.pageCount}</span>
            <button className="btn btn-sm btn-outline" disabled={pager.currentPage >= pager.pageCount || loading} onClick={() => { const p = Math.min(pager.pageCount, pager.currentPage + 1); setPage(p); loadTemplates(p, search); }}>Próximo</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signature;